import { ChangeEvent, useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

interface Student {
    name: string;
    uid: string;
    status?: 'active' | 'suspended' | 'graduated';
}

const useViewStudent = (lesson:string) => {
    const {getBranchId} = useGetBranchId();
    const {readFirestoreOneDoc} = useFirestore();
    const [students, setStudents] = useState<Student[]>([]);
    const [searchedStudents, setSearchedStudents] = useState<Student[]>([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        if(lesson){
           getAssignedStudents();
        }
        // eslint-disable-next-line
    }, [lesson])

    const getAssignedStudents = async() => {
        setStudents([]);
        setSearchedStudents([]);
        const branch_id = await getBranchId();
        const student_uid_list = await readFirestoreOneDoc(`Assign/${branch_id}/Lesson`, lesson).then(res => {
            if(res.exists()){
                return res.data().students;
            }
            return [];
        })

        const studentPromises = student_uid_list.map((uid: string) => 
            readFirestoreOneDoc('User/Auth/Student', uid).then(res => {
                if(res.exists()){
                    const data = res.data();
                    return {name: data.name, uid: uid, status: data.status};
                }
                return null;
            })
        );

        const students = await Promise.all(studentPromises);
        const activeStudents = students
            .filter((student): student is Student => 
                student !== null && (student.status === 'active' || student.status === undefined)
            )
            .sort((a, b) => a.name.localeCompare(b.name));
        
        setStudents(activeStudents);
        setSearchedStudents(activeStudents);
    }

    useEffect(() => {
        const searchedItems = students.filter((item) => item.name.includes(search));
        setSearchedStudents(searchedItems);
        // eslint-disable-next-line
    }, [search])

    const onChange = (e:ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    }

    return {searchedStudents, search, onChange}
}

export default useViewStudent;